var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartPulse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-heart-pulse",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385h1.12a.5.5 0 0 1 .448.276L4 9.142l1.395-4.187a.5.5 0 0 1 .948 0L7.5 8.432l.026-.05A.5.5 0 0 1 7.97 8.1h2.166c-.625-.612-1.55-1.426-2.166-2.149L8 5.79l-1.5 1.5a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0L8.5 5.79c.604.722 1.5 1.583 2.116 2.31h2.456a.5.5 0 0 1 .448.276l.43.86h1.198c.952-1.886.834-3.362.312-4.385C14.347.878 11.262.28 9.738 1.99zM8 1.207c2.014-1.946 5.738-1.072 6.99 1.371C16.292 5.024 16.025 8 8 16 -.025 8-.292 5.024 1.01 2.578 2.262.135 5.987-.74 8 1.207"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.583 8.585a.5.5 0 0 1 .833-.16L5.5 9.83l1.395-4.186a.5.5 0 0 1 .948 0L9.05 9.464l.025-.05a.5.5 0 0 1 .448-.276h2.5a.5.5 0 0 1 0 1h-2.19l-.4.797a.5.5 0 0 1-.916-.054l-1.143-3.43-1.395 4.187a.5.5 0 0 1-.911.073L3.582 8.586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPulse);
export default __webpack_public_path__ + "static/media/heart-pulse.acb15d223386b7105c48fea19462e380.svg";
export { ForwardRef as ReactComponent };